import React from "react";
 import  { useState, useEffect } from 'react';
 import { DataGrid } from '@mui/x-data-grid';
 import { configData } from "../config";
 import { Link } from '@mui/material';
import { Helmet } from 'react-helmet';
import './classes/ManagePeople.css';
import SalespersonSidebar from "./SalespersonSidebar";
import Loading from './Loading';
// import { useMockServer } from '@mui/x-data-grid-generator';

 
const columns = [
  
  { field: 'U.username', headerName: 'Username',cellClassName:'user_name_column',headerClassName:'user_name_header', width: 200,renderCell: (params) => (
      <Link href={params.row.url} target="_blank" rel="noopener noreferrer" style={{ color: "#2C99D2"}}>
        {params.row.username}
      </Link>
    )},
  { field: 'U.first_name', headerName: 'First Name',cellClassName:'first_name_column',headerClassName:'first_name_header' },
  { field: 'U.last_name', headerName: 'Last Name',cellClassName:'last_name_column',headerClassName:'last_name_header'},
  { field: 'UR.rid', headerName: 'Roles',sortable: false,cellClassName:'roles_column',headerClassName:'roles_header'},
  { field: 'U.status', headerName: 'Active',cellClassName:'active_column',headerClassName:'active_header',renderCell: (params) => (
      <img src={params.row.status}></img>
    )},
  { field: 'U.created_at', headerName: 'Created date',cellClassName:'created_column',headerClassName:'created_header'},
  {
    field: 'edit_link',
    headerName: 'Edit Link',
    cellClassName:'edit_column',headerClassName:'edit_header',
    renderCell: (params) => (
      <Link href={params.row.edit_url} target="_blank" rel="noopener noreferrer"  style={{ color: "#2C99D2"}}>
        Edit
      </Link>
    ),
    sortable: false
  },
];

const ManageAdminPeople =() =>{
  /* Pagination, filter config starts here */
const [rows, setRows] = React.useState([]);
  const [rowCount, setRowCount] = React.useState(0);
  const [paginationModel, setPaginationModel] = React.useState({ page: 0, pageSize: 50 });
  const [sortModel, setSortModel] = React.useState([]);
  const [filterModel, setFilterModel] = React.useState({ items: [] });
  const [roleList, setrolelist] = useState({});
  const [isLoading, setIsLoading] = useState(true);
const app_url = configData.APP_URL;
const [formData, setformData] = useState({
        field_first_name_value: '',
        field_last_name_value:'',
        rid: '',
        name: '',
        mail: '',
        status: '',
       field_dormant_value: ''
    });
const handleChange = (event) => {
    const { name, value } = event.target;
    setformData({ ...formData, [name]: value });
    
  };
  useEffect(() => {
          Promise.all([
              retrieveroleslist()
          ])
          .then(() => {
       
          setIsLoading(false);
          })
       
      },[]);
      async function retrieveroleslist() {
    
       
            const response = await fetch(
                 app_url+'user/getfullroleslist',
                {
                    method: "GET",
  
                    headers: {
                    'Content-Type': 'application/json',
                    },
                }
            )           
            const responsedata = await response.json();
            if(responsedata.data.msg === "Success") {
                setrolelist(responsedata.data.result);
            }
       
    }
  React.useEffect(() => { 
    const fetchData = async () => {
      // Simulate API call to your server
      // In a real application, replace this with your actual fetch logic
       try {
        setIsLoading(true);
      const response = await fetch(app_url+'user/getadminuserlist', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          page: paginationModel.page,
          pageSize: paginationModel.pageSize,
          sortModel,
          filterModel,
          formData:formData
        }),
      });
      const data = await response.json();
      console.log(data.data.rows);
      setRows(data.data.rows);
      setRowCount(data.data.totalRowCount); // Server should return totalRowCount
      }  catch (error) {
            console.error('Error fetching data:', error);
          } finally {
            setIsLoading(false); // Set loading to false after fetch completes (success or error)
          }
    };
    

    fetchData();
  }, [paginationModel, sortModel, filterModel]); // Re-fetch data when these change


  /* Pagination, filter config ends here */

const handleSubmit = async (e) => {
  e.preventDefault();
  try {
     setIsLoading(true);
const response = await fetch(app_url+'user/getadminuserlist', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          page: paginationModel.page,
          pageSize: paginationModel.pageSize,
          sortModel,
          filterModel,
          formData:formData
        }),
      });
      const data = await response.json();
      console.log(data.data.rows);
      setRows(data.data.rows);
      setRowCount(data.data.totalRowCount); // Server should return totalRowCount
      }  catch (error) {
            console.error('Error fetching data:', error);
          } finally {
            setIsLoading(false); // Set loading to false after fetch completes (success or error)
          }
  
}; 
 
    return(
        <>
         {isLoading ? (
              <Loading />
            ) : (
        <div id="main">
            <Helmet><title>Manage People</title></Helmet>
           <div class="left"></div>
               
               <div class="center left-center">
                    <div className="manage_people-container">
                        <div className="manage_people-view-header">
                             <div className="header-actions">
                                <a href="/admin/people/create" className="form-submit  manage_people_adduserbtn">Add user</a>
                                <a href="/user-advance-search" className="form-submit manage_people_advancedsearch" style={{marginLeft:"10px",}} target="_blank" rel="noopener noreferrer">
                                Advanced Search
                                </a>
                            </div>                         
                         </div>
                           <div className="manage_people-view-filters">
                                <form id="views-exposed-form-sa-admin-user-list-page">
                                    <div className="manage_people-views-exposed-form">
                                    <div className="manage_people-views-exposed-widgets">

                                        {/* First Name */}
                                        <div
                                        id="edit-field-first-name-value-wrapper"
                                        className="manage_people-views-exposed-widget manage_people-views-widget-filter-field_first_name_value"
                                        >
                                        <label htmlFor="edit-field-first-name-value">First Name</label>
                                        <div className="manage_people-views-widget">
                                            <div className="manage_people-form-item">
                                            <input
                                                type="text"
                                                id="edit-field-first-name-value"
                                                name="field_first_name_value"
                                                size="30"
                                                maxLength="128"
                                                value= {formData.field_first_name_value}
                                                className="manage_people-form-text" onChange={handleChange}
                                            />
                                            </div>
                                        </div>
                                        </div>

                                        {/* Last Name */}
                                        <div
                                        id="edit-field-last-name-value-wrapper"
                                        className="manage_people-views-exposed-widget manage_people-views-widget-filter-field_last_name_value"
                                        >
                                        <label htmlFor="edit-field-last-name-value">Last Name</label>
                                        <div className="manage_people-views-widget">
                                            <div className="manage_people-form-item">
                                            <input
                                                type="text"
                                                id="edit-field-last-name-value"
                                                name="field_last_name_value"
                                                size="30"
                                                maxLength="128" value= {formData.field_last_name_value}
                                                className="manage_people-form-text" onChange={handleChange}
                                            />
                                            </div>
                                        </div>
                                        </div>

                                        {/* Roles */}
                                        <div
                                        id="edit-rid-wrapper"
                                        className="manage_people-views-exposed-widget manage_people-views-widget-filter-rid"
                                        >
                                        <label htmlFor="edit-rid">Roles</label>
                                        <div className="manage_people-views-widget">
                                            <div className="manage_people-form-item">
                                            <select id="edit-rid" name="rid" className="manage_people-form-select" value= {formData.rid} onChange={handleChange}>
                                                <option value="All">- Any -</option>
                                                {roleList.length > 0 && ( 
                                                  <>
                                                    {roleList.map(({ id, name }) => (
                                                     <><option value={id}>{name}</option></>
                                                    ))}
                                                  </>
                                                )}
                                                
                                            </select>
                                            </div>
                                        </div>
                                        </div>

                                        {/* User Name */}
                                        <div
                                        id="edit-name-wrapper"
                                        className="manage_people-views-exposed-widget manage_people-views-widget-filter-name"
                                        >
                                        <label htmlFor="edit-name">User Name</label>
                                        <div className="manage_people-views-widget">
                                            <div className="manage_people-form-item">
                                            <input
                                                type="text"
                                                id="edit-name"
                                                name="name"
                                                size="30"
                                                maxLength="128" value= {formData.name} 
                                                className="manage_people-form-text" onChange={handleChange}
                                            />
                                            </div>
                                        </div>
                                        </div>
                                        <div className="clear"></div>
                                        {/* E-mail */}
                                        <div
                                        id="edit-mail-wrapper"
                                        className="manage_people-views-exposed-widget manage_people-views-widget-filter-mail"
                                        >
                                        <label htmlFor="edit-mail">E-mail</label>
                                        <div className="manage_people-views-widget">
                                            <div className="manage_people-form-item">
                                            <input
                                                type="text"
                                                id="edit-mail"
                                                name="mail"
                                                size="30"
                                                maxLength="128" value= {formData.mail}  
                                                className="manage_people-form-text" onChange={handleChange}
                                            />
                                            </div>
                                        </div>
                                        </div>

                                        {/* Status */}
                                        <div
                                        id="edit-status-wrapper"
                                        className="manage_people-views-exposed-widget manage_people-views-widget-filter-status"
                                        >
                                        <label htmlFor="edit-status">Status</label>
                                        <div className="manage_people-views-widget">
                                            <div className="manage_people-form-item">
                                            <select id="edit-status" name="status" className="manage_people-form-select"  value= {formData.status}   onChange={handleChange}>
                                                <option value="All">- Any -</option>
                                                <option value="1">Yes</option>
                                                <option value="0">No</option>
                                            </select>
                                            </div>
                                        </div>
                                        </div>

                                        {/* Dormant */}
                                        <div
                                        id="edit-field-dormant-value-wrapper"
                                        className="manage_people-views-exposed-widget manage_people-views-widget-filter-field_dormant_value"
                                        >
                                        <label htmlFor="edit-field-dormant-value">Dormant</label>
                                        <div className="manage_people-views-widget">
                                            <div className="manage_people-form-item">
                                            <select
                                                id="edit-field-dormant-value"
                                                name="field_dormant_value" value= {formData.field_dormant_value}
                                                className="manage_people-form-select" onChange={handleChange}
                                            >
                                                <option value="All">- Any -</option>
                                                <option value="0">Off</option>
                                                <option value="1">On</option>
                                            </select>
                                            </div>
                                        </div>
                                        </div>

                                        {/* Submit Button */}
                                        <div className="manage_people-views-exposed-widget manage_people-views-submit-button">
                                        
                                        <button className='form-submit manage_people-formsubmit' type="submit" onClick={handleSubmit}>Apply</button>
                                        </div>

                                    </div>
                                    </div>
                                </form>
                              </div>
                      
                        <div className="manage_people-view-content">
                            <table className="manage_people-views-table">
                                   <div style={{ width: '100%' }}>
                                    <DataGrid
                                                                        rows={rows}
                                                                        columns={columns}
                                                                        rowCount={rowCount}
                                                                        paginationMode="server"
                                                                        sortingMode="server"
                                                                        filterMode="server"
                                                                        paginationModel={paginationModel}
                                                                        onPaginationModelChange={setPaginationModel}
                                                                        sortModel={sortModel}
                                                                        onSortModelChange={setSortModel}
                                                                         filterModel={filterModel}
                                                                        onFilterModelChange={setFilterModel}
                                                                        pageSizeOptions={[5, 10, 25,50]}
                                                                        getRowId={() => crypto.randomUUID()}
                                                                        getRowHeight={() => 'auto'}
                                                                        disableColumnFilter 
                                                                        disableColumnResize={true}
                                                                    />
    </div>
                            </table>
                        </div>

                   
                </div>
        </div>
        <div class="right">
            <SalespersonSidebar/>
        </div>
        </div>
        
     )}
    </>
  )
};

export default ManageAdminPeople;